module.exports = __webpack_public_path__ + "img/bg.a8fba150.png";